import React, { useCallback } from "react";

import identity from "lodash-es/identity";
import { useIntl } from "react-intl";

import { EntityType, EntityTypeSupportingGroups } from "@mapmycustomers/shared/types/entity";

import { SelectEntityDialogProps } from "@app/component/SelectEntityDialog/selectEntityDialogFactory";
import selectRecordTypesDialogFactory from "@app/component/SelectEntityDialog/SelectRecordTypesDialogFactory";
import { getEntityTypeDisplayName } from "@app/util/ui";

const SelectRecordTypes = selectRecordTypesDialogFactory<EntityTypeSupportingGroups>();

const initialRecordTypes: EntityTypeSupportingGroups[] = [
  EntityType.COMPANY,
  EntityType.DEAL,
  EntityType.PERSON,
];

type Props = Omit<
  SelectEntityDialogProps<EntityTypeSupportingGroups>,
  "entities" | "getDisplayName" | "getKey" | "id"
>;

const RecordTypesModal: React.FC<Props> = (props) => {
  const intl = useIntl();

  const displayNameGetter = useCallback(
    (entityType) => getEntityTypeDisplayName(intl, entityType, { lowercase: false, plural: true }),
    [intl]
  );

  return (
    <SelectRecordTypes
      entities={initialRecordTypes}
      getDisplayName={displayNameGetter}
      getKey={identity}
      {...props}
    />
  );
};

export default RecordTypesModal;
